import { c as _c } from "react/compiler-runtime";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { ReserveRateFooter } from "@website/widget/reserve-rate/reserve-rate-footer";
import { ReserveRateHeader } from "@website/widget/reserve-rate/reserve-rate-header";
import { ReserveProgressBar } from "@website/widget/reserve-rate/reserve-rate-progress-bar";
import { ReserveRateEnum, ReserveRatePropertiesTypes, ReserveRateTypes, ReserveVillaRateEnum } from "@website/widget/reserve-rate/reserve-rate.types";
import { useRouter } from "next/router";
export const ReserveRate = properties => {
  const $ = _c(33);
  const {
    rate,
    rateCount,
    offerCount,
    offerMessage,
    rateDetail,
    showTitle: t0,
    size: t1,
    hasBackground: t2,
    hotelType,
    sectionTitle,
    aiSummary,
    showFooter: t3
  } = properties;
  const showTitle = t0 === undefined ? true : t0;
  const size = t1 === undefined ? "large" : t1;
  const hasBackground = t2 === undefined ? true : t2;
  const showFooter = t3 === undefined ? true : t3;
  const router = useRouter();
  if (!rateCount || !rate || Number(rate) < 1) {
    return null;
  }
  const t4 = `${size === "medium" ? "bg-dim-background h-fit min-w-[324px] rounded-lg p-4 xl:bg-white" : "min-w-[312px]"} ${aiSummary ? "" : "!w-full"}`;
  let t5;
  if ($[0] !== hotelType || $[1] !== sectionTitle || $[2] !== showTitle) {
    t5 = showTitle && <h2 className="text-subtitle-1 md:text-headline-6 mb-4">{sectionTitle ?? replaceSnappTripBasedOnChannel(`امتیاز ${hotelType} از دید کاربران اسنپ‌تریپ`)}</h2>;
    $[0] = hotelType;
    $[1] = sectionTitle;
    $[2] = showTitle;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = `flex min-w-[218px] flex-col gap-4 rounded-[8px] md:w-full lg:max-w-[1200px] xl:rounded-[8px] ${size === "large" ? "xl:max-w-[1200px] xl:rounded-[8px] xl:px-10 xl:py-8" : ""} ${hasBackground ? "bg-dim-background p-6 xl:px-10 xl:py-8" : ""}`;
  const t7 = `flex flex-col gap-4 ${size === "large" ? "xl:flex-row xl:items-center xl:gap-[40px]" : ""}`;
  let t8;
  if ($[4] !== rate || $[5] !== rateCount || $[6] !== size) {
    t8 = <ReserveRateHeader properties={{
      rate,
      rateCount,
      size
    }} />;
    $[4] = rate;
    $[5] = rateCount;
    $[6] = size;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = `bg-outline-thin hidden h-[72px] w-px ${size === "large" ? "xl:block" : ""}`;
  let t10;
  if ($[8] !== t9) {
    t10 = <div className={t9} />;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = `grid w-full gap-x-[40px] gap-y-4 lg:gap-y-1 ${size === "large" ? "xl:grid-cols-2" : ""}`;
  let t12;
  if ($[10] !== rateDetail || $[11] !== router) {
    t12 = Object.keys(rateDetail)?.map(key => {
      if (!rateDetail[key as ReserveRateTypes]) {
        return null;
      }
      return <div className="flex flex-row items-start gap-4 lg:flex-col lg:gap-1" key={key}><div className="text-caption md:text-body-2 w-[152px] md:w-[178px]">{process.env.NEXT_PUBLIC_APP_NAME === "villa" ? ReserveVillaRateEnum[key as ReserveRateTypes] : ReserveRateEnum[key as ReserveRateTypes]}</div><div className="flex w-full flex-row items-center gap-1"><ReserveProgressBar properties={{
            limit: 5,
            progress: Number(rateDetail[key as ReserveRateTypes])
          }} /><div className="text-caption md:text-body-2">{numberConvert(rateDetail[key as ReserveRateTypes], {
              locale: router.locale
            })}</div></div></div>;
    });
    $[10] = rateDetail;
    $[11] = router;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11 || $[14] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t10 || $[17] !== t13 || $[18] !== t7 || $[19] !== t8) {
    t14 = <div className={t7}>{t8}{t10}{t13}</div>;
    $[16] = t10;
    $[17] = t13;
    $[18] = t7;
    $[19] = t8;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t6) {
    t15 = <div className={t6}>{t14}</div>;
    $[21] = t14;
    $[22] = t6;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== offerCount || $[25] !== offerMessage || $[26] !== showFooter) {
    t16 = Boolean(offerCount) && showFooter && <ReserveRateFooter properties={{
      offerCount,
      offerMessage
    }} />;
    $[24] = offerCount;
    $[25] = offerMessage;
    $[26] = showFooter;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15 || $[29] !== t16 || $[30] !== t4 || $[31] !== t5) {
    t17 = <div className={t4}>{t5}{t15}{t16}</div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t4;
    $[31] = t5;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
};